export const STEPS = [
  { id: 'basics', title: '1. Basics' },
  { id: 'variables', title: '2. Variables' },
  { id: 'messages', title: '3. Messages' },
];

export const emptyTemplate = () => ({
  name: '',
  description: '',
  source_type: 'http',
  data_source_url: '',
  method: 'GET',
  headersText: '{}',
  queryParamsText: '{}',
  requestBodyText: '{}',
  mongodb_uri: '',
  mongodb_database: '',
  mongodb_collection: '',
  mongodb_filterText: '{}',
  mongodb_sort_field: '_id',
  email_subject: 'Alert Notification',
  email_template: '',
  whatsapp_mode: 'text',
  whatsapp_template: '',
  whatsapp_template_name: '',
  whatsapp_template_lang: 'en',
  whatsapp_paramText: '[]',
  batch_size: 10,
  is_active: true,
  variableRows: [{ key: '', path: '', format: 'none', timestampFormat: 'YYYY-MM-DD HH:mm:ss', timezone: '' }],
});

export function objectToText(value) {
  return JSON.stringify(value || {}, null, 2);
}

export function asText(value) {
  return typeof value === 'string' ? value : '';
}

export function parseJson(text, label) {
  try {
    const normalized = asText(text);
    return normalized.trim() ? JSON.parse(normalized) : {};
  } catch {
    throw new Error(`${label} must be valid JSON`);
  }
}

export function parseWhatsAppParamList(text) {
  const normalized = asText(text).trim();
  if (!normalized) return [];

  try {
    const parsed = JSON.parse(normalized);
    if (!Array.isArray(parsed)) {
      throw new Error();
    }
    return parsed.map((item) => String(item).trim()).filter(Boolean);
  } catch {
    return normalized
      .replace(/^\[/, '')
      .replace(/\]$/, '')
      .split(/[,\n]/)
      .map((item) => item.trim().replace(/^["']|["']$/g, ''))
      .filter(Boolean);
  }
}

export function normalizeDetail(detail) {
  return {
    id: detail.id,
    name: detail.name || '',
    description: detail.description || '',
    source_type: detail.source_type || 'http',
    data_source_url: detail.data_source_url || '',
    method: detail.method || 'GET',
    headersText: objectToText(detail.headers),
    queryParamsText: objectToText(detail.query_params),
    requestBodyText: objectToText(detail.request_body),
    mongodb_uri: detail.mongodb_uri || '',
    mongodb_database: detail.mongodb_database || '',
    mongodb_collection: detail.mongodb_collection || '',
    mongodb_filterText: objectToText(detail.mongodb_filter),
    mongodb_sort_field: detail.mongodb_sort_field || '_id',
    email_subject: detail.email_subject || 'Alert Notification',
    email_template: detail.email_template || '',
    whatsapp_mode: detail.whatsapp_mode || 'text',
    whatsapp_template: detail.whatsapp_template || '',
    whatsapp_template_name: detail.whatsapp_template_name || '',
    whatsapp_template_lang: detail.whatsapp_template_lang || 'en',
    whatsapp_paramText: objectToText(detail.whatsapp_param_map),
    batch_size: detail.batch_size || 10,
    is_active: detail.is_active !== false,
    variableRows: Object.entries(detail.variable_mapping || {}).length
      ? Object.entries(detail.variable_mapping).map(([key, mapping]) => {
          const isConfigObject = mapping && typeof mapping === 'object';
          return {
            key,
            path: isConfigObject ? mapping.path || '' : mapping || '',
            format: isConfigObject && mapping.format === 'timestamp' ? 'timestamp' : 'none',
            timestampFormat: (isConfigObject && mapping.timestampFormat) || 'YYYY-MM-DD HH:mm:ss',
            timezone: (isConfigObject && mapping.timezone) || '',
          };
        })
      : [{ key: '', path: '', format: 'none', timestampFormat: 'YYYY-MM-DD HH:mm:ss', timezone: '' }],
  };
}

export function buildPayload(form) {
  const variable_mapping = {};
  for (const row of form.variableRows) {
    const key = asText(row.key).trim();
    const path = asText(row.path).trim();
    if (!key || !path) continue;

    variable_mapping[key] = row.format === 'timestamp'
      ? {
          path,
          format: 'timestamp',
          timestampFormat: asText(row.timestampFormat).trim() || 'YYYY-MM-DD HH:mm:ss',
          timezone: asText(row.timezone).trim() || undefined,
        }
      : path;
  }

  return {
    name: asText(form.name).trim(),
    description: asText(form.description).trim(),
    source_type: form.source_type,
    data_source_url: form.source_type === 'http' ? asText(form.data_source_url).trim() : null,
    method: form.method,
    headers: parseJson(form.headersText, 'Headers'),
    query_params: parseJson(form.queryParamsText, 'Query params'),
    request_body: parseJson(form.requestBodyText, 'Request body'),
    mongodb_uri: form.source_type === 'mongodb' ? asText(form.mongodb_uri).trim() : null,
    mongodb_database: form.source_type === 'mongodb' ? asText(form.mongodb_database).trim() : null,
    mongodb_collection: form.source_type === 'mongodb' ? asText(form.mongodb_collection).trim() : null,
    mongodb_filter: form.source_type === 'mongodb' ? parseJson(form.mongodb_filterText, 'MongoDB filter') : {},
    mongodb_sort_field: form.source_type === 'mongodb' ? asText(form.mongodb_sort_field).trim() || '_id' : '_id',
    variable_mapping,
    email_subject: asText(form.email_subject).trim() || 'Alert Notification',
    email_template: asText(form.email_template),
    whatsapp_mode: form.whatsapp_mode,
    whatsapp_template: asText(form.whatsapp_template),
    whatsapp_template_name: form.whatsapp_mode === 'api_template' ? asText(form.whatsapp_template_name).trim() : null,
    whatsapp_template_lang: form.whatsapp_mode === 'api_template' ? asText(form.whatsapp_template_lang).trim() || 'en' : 'en',
    whatsapp_param_map: form.whatsapp_mode === 'api_template' ? parseWhatsAppParamList(form.whatsapp_paramText) : [],
    batch_size: Number(form.batch_size) || 10,
    is_active: !!form.is_active,
  };
}
